import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import {  searchCustomer } from "src/apis/customerApi";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";


import { BRDiv, inputFormHeightOption } from "src/components/common/common";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { KioskSwitchButtonForm } from "src/components/common/form/KioskSwitchButtonForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { KSK1070_R01HeaderDto } from "./Dto_KSK1070_R01";
import { useKSK1070_R01Store } from "./Store_KSK1070_R01";
import { formatDate } from "src/utils/string/stringUtil";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig, InfoFieldHandlers } from "src/types/info-form";



interface Props {
	editable: boolean
	defaultKSK1070_R01HeaderRow: KSK1070_R01HeaderDto;
	getWmsOrderFieldHandlers: (fieldName: string) => InfoFieldHandlers;
	onSearchClick: () => void;
	handleFetchDetailList: (wmsOrderNo: string, warehouseCd: string, isNewSelection: boolean, previousOrderNo: string | undefined) => void;
}

export const Info_KSK1070_R01 = (props: Props) => {

	const {
		defaultKSK1070_R01HeaderRow,
		getWmsOrderFieldHandlers,
		onSearchClick,
		handleFetchDetailList,
	} = props;

	const { inoutClassList, wmsCdList, compCdList, } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const {
			editKSK1070_R01, setEditKSK1070_R01,
			transportComplete,
			warehouseCdListToUseList,
			KSK1070_R01Filter,
			setKSK1070_R01Filter,
			setDetailFetchTrigger,
	} = useKSK1070_R01Store();


	const custInfoHandleFoucsId = 'infoCustInput';
	const empInfoHandleFoucsId = 'infoEmpInput';
	const wmsOrderInfoHandleFocusId = 'inputWmsOrderNo_search';

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
				telNo: 'telNo',
				faxNo: 'faxNo',
				moneyCd: 'moneyCd',
				taxEmail: 'email',
				post: 'post',
				address: 'address',
				detailAddress: 'otherAddress',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: editKSK1070_R01?.customCd || '',
				customNm: editKSK1070_R01?.customNm || '',
			}),
		},
		{
			fieldName: 'empNo',
			category: '담당자',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo: 'empNo',
				empNm: 'empNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			},
			extraFilter: () => ({
				empNo: editKSK1070_R01?.empNo || '',
				empNm: editKSK1070_R01?.empNm || '',
			}),
		}
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editKSK1070_R01,
		setEditData: setEditKSK1070_R01,
		defaultData: defaultKSK1070_R01HeaderRow,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK1070_R01'
	});

	// 입고일자 달력 팝업 상태
	const [orderPickerVisible, setOrderPickerVisible] = useState(false);
	const [orderPickerPos, setOrderPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});
	const [deadlinePickerVisible, setDeadlinePickerVisible] = useState(false);
	const [deadlinePickerPos, setDeadlinePickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	const prevWarehouseCdRef = useRef<string | undefined>(undefined);
	const prevWmsOrderNoRef = useRef<string | undefined>(undefined);
	
	useEffect(() => {
		const warehouseCd = editKSK1070_R01?.warehouseCd;
		const wmsOrderNo = editKSK1070_R01?.wmsOrderNo;

		if (!warehouseCd || !wmsOrderNo) {
			prevWarehouseCdRef.current = warehouseCd;
			prevWmsOrderNoRef.current = wmsOrderNo;
			return;
		}

		const warehouseChanged = prevWarehouseCdRef.current !== undefined
			&& prevWarehouseCdRef.current !== warehouseCd;
		const sameOrder = prevWmsOrderNoRef.current === wmsOrderNo;

		prevWarehouseCdRef.current = warehouseCd;
		prevWmsOrderNoRef.current = wmsOrderNo;

		if (warehouseChanged && sameOrder) {
			handleFetchDetailList(wmsOrderNo, warehouseCd, true, undefined);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- warehouse 변경만 감지
	}, [editKSK1070_R01?.warehouseCd]);


	const handleDateChange = useCallback((field: keyof KSK1070_R01HeaderDto, value: any) => {
		setEditKSK1070_R01({
			...defaultKSK1070_R01HeaderRow,
			...editKSK1070_R01,
			[field]: value
		});
	}, [editKSK1070_R01, defaultKSK1070_R01HeaderRow, setEditKSK1070_R01]);

	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		let additionalUpdates = {};
		// 입고물류(logicCenter)가 변경될 때, 해당 물류의 첫 번째 창고로 warehouseCd 자동 세팅
		if (name === 'logicCenter') {
			const availableWarehouses = warehouseCdListToUseList(value);
			additionalUpdates = {
				warehouseCd: availableWarehouses[0]?.warehouseCd || ''
			};
		}

		setEditKSK1070_R01({
			...defaultKSK1070_R01HeaderRow,
			...editKSK1070_R01,
			[name]: value,
			...additionalUpdates
		});
	}, [editKSK1070_R01, defaultKSK1070_R01HeaderRow, warehouseCdListToUseList, setEditKSK1070_R01]);



	return (
		<div className="w-full h-full flex flex-wrap content-start overflow-y-auto">
				<div className="w-full flex flex-wrap items-center gap-[8px]">
					<CodeForm
						label="입고지시번호"
						value={editKSK1070_R01?.wmsOrderNo || ""}
						custNmValue=""
						editable={true}
						custNmInputless={true}
						handleFoucsId={wmsOrderInfoHandleFocusId}
						name="wmsOrderNo"
						handleChange={getWmsOrderFieldHandlers('wmsOrderNo').onChange}
						onDoubleClick={getWmsOrderFieldHandlers('wmsOrderNo').onDoubleClick}
						onKeyDown={getWmsOrderFieldHandlers('wmsOrderNo').onEnterKeyDown}
						wrapperOption={{
							wrapperStyle: "w-[400px] min-w-[400px] mb-[4px]",
							titleStyle: "w-[150px] min-w-[150px] text-left",
							codeInputStyle: "w-[240px] min-w-[240px] " + inputFormHeightOption,
							custNmInputStyle: "w-[105px] min-w-[105px]"
						}}
					/>
					<button
						className={`text-white bg-blue-dark items-center justify-center px-[8px] py-[2px] rounded-[4px] w-[74px] mb-[4px] flex-shrink-0 ${inputFormHeightOption}`}
						onClick={onSearchClick}
					>
						조회
					</button>
				</div>
				<BRDiv />

				<DropDownForm
					title="사업장"
					name="compCd"
					initLabelLess={true}
					value={editKSK1070_R01?.compCd}
					data={compCdList}
					editable={!transportComplete}
					onChange={handleChange}
				/>
				<SingleDateForm
					title="입고일자"
					value={editKSK1070_R01?.orderDt ? new Date(editKSK1070_R01.orderDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('orderDt', formatDate(value))}
					editable={true}
					visible={orderPickerVisible}				setVisible={setOrderPickerVisible}
					onChange={handleChange}
					pickerPos={orderPickerPos}						setPickerPos={setOrderPickerPos}
				/>
				<BRDiv />


				<DropDownForm
					title="입고구분"
					name="inoutClass"
					initLabelLess={false}
					value={editKSK1070_R01?.inoutClass} // 입고구분값 110으로 고정
					data={inoutClassList}
					editable={false}
					onChange={handleChange}
				/>
				<BRDiv />

				<CodeForm
					label="거래처"
					value={editKSK1070_R01?.customCd || ""}
					custNmValue={editKSK1070_R01?.customNm || ""}
					editable={false}
					handleFoucsId={custInfoHandleFoucsId}
					name="customCd"
					handleChange={getFieldHandlers('customCd').onChange}
					onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
					onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
				/>
				<CodeForm
					label="입고담당자"
					value={editKSK1070_R01?.empNo || ""}
					custNmValue={editKSK1070_R01?.empNm || ""}
					editable={!transportComplete}
					handleFoucsId={empInfoHandleFoucsId}
					name="empNo"
					handleChange={getFieldHandlers('empNo').onChange}
					onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
					onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
				/>
				<BRDiv />
				
				<DropDownForm<SysCodeDto> 
						title="입고물류"
						data={wmsCdList}
						value={editKSK1070_R01?.logicCenter || ""}
						name="logicCenter" 
						editable={editKSK1070_R01?.closeTag === 'N'}
						initLabelLess={true}
						onChange={handleChange} />
				<DropDownForm
					title="창고번호"
					name="warehouseCd"
					initLabelLess={true}
					value={editKSK1070_R01?.warehouseCd}
					data={warehouseCdListToUseList(editKSK1070_R01?.logicCenter || '')}
					editable={editKSK1070_R01?.closeTag === 'N'}
					onChange={handleChange}
				/>
				<BRDiv />

				<SingleDateForm
					title="납기일자"
					value={editKSK1070_R01?.deadlineDt ? new Date(editKSK1070_R01.deadlineDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('deadlineDt', formatDate(value))}
					editable={!transportComplete}
					visible={deadlinePickerVisible}				setVisible={setDeadlinePickerVisible}
					onChange={handleChange}
					pickerPos={deadlinePickerPos}						setPickerPos={setDeadlinePickerPos}
				/>
				<BRDiv />
				
				<InputForm
					title="비고"
					value={editKSK1070_R01?.remark || ""}
					editable={!transportComplete}
					name="remark"
					wrapperOption={{
						wrapperStyle: "w-[510px] min-w-[510px] mr-[10px] mb-[5px]",
						titleStyle: "w-[150px] min-w-[150px] text-left",
						inputStyle: "w-full min-w-full"
					}}
					onChange={handleChange}
				/>
				<BRDiv />

				<KioskSwitchButtonForm
					title="라벨자동출력"
					name="labelPrintAuto"
					value={KSK1070_R01Filter.labelPrintAuto as 'Y' | 'N'}
					onChange={(name, value) => setKSK1070_R01Filter({ [name]: value })}
				/>
		</div>
	)
}
